import "./CardBlock.scss";

function CardBlock({ icon, image, imageAlt, title, body, variant = "default" }) {
    const hasImage = Boolean(image?.trim());
    const hasIcon = Boolean(icon) && !hasImage;

    return (
        <div className={`card-block card-block--${variant}`}>
            {hasImage && (
                <div className="card-block__image-wrapper">
                    <img
                        className="card-block__image"
                        src={image}
                        alt={imageAlt || title || ""}
                    />
                </div>
            )}

            {hasIcon && (
                <div className="card-block__icon-wrapper">
                    <i
                        className={`card-block__icon fa-duotone fa-lg ${icon}`}
                        aria-hidden="true"
                    />
                </div>
            )}

            <div className="card-block__content">
                {title && <h3 className="card-block__title">{title}</h3>}
                <p className="card-block__body">{body}</p>
            </div>
        </div>
    );
}

export default CardBlock;
